import { useEffect, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Moon } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const booking = params.get("booking");
  const sent = useRef(false);

  useEffect(() => {
    if (booking && !sent.current) {
      sent.current = true;
      api.post(`/bookings/${booking}/cancel`).catch(() => {});
    }
  }, [booking]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-20" data-testid="payment-cancel">
      <div className="max-w-xl w-full glass rounded-[2rem] p-8 md:p-14 text-center rise">
        <Moon className="mx-auto text-gold" size={36} strokeWidth={1.4} />
        <p className="eyebrow mt-6">No worries, beloved soul</p>
        <h1 className="font-display gold-text text-3xl md:text-4xl mt-3">Donation cancelled</h1>
        <p className="mt-5 text-[#f7f1e1]/80">You have not been charged. When you feel ready, you can try again. The door is always open.</p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Link to="/" onClick={() => setTimeout(() => document.getElementById("donate")?.scrollIntoView(), 400)} className="btn-gold" data-testid="payment-try-again-btn">Try Again</Link>
          <Link to="/" className="btn-ghost" data-testid="back-home-link">Return Home</Link>
        </div>
      </div>
    </main>
  );
}
